
import { ref, watch } from '@vue/composition-api';
interface Props {
  name: string;
  toggle: boolean;
  activeCount: number;
}
const __sfc_main = {};
__sfc_main.props = {
  name: {
    key: "name",
    required: true,
    type: String
  },
  toggle: {
    key: "toggle",
    required: false,
    type: Boolean,
    default: false
  },
  activeCount: {
    key: "activeCount",
    required: false,
    type: Number,
    default: 0
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const innerToggle = ref(props.toggle);
  watch(() => props.toggle, (val: boolean) => {
    innerToggle.value = val;
  });
  function toggleVisibility() {
    innerToggle.value = !innerToggle.value;
  }
  return {
    innerToggle,
    toggleVisibility
  };
};
export default __sfc_main;
